import { ReactNode, useCallback, useEffect, useRef, useState } from 'react';

import { Toast } from '@ui/components/Toast';

const TOAST_AUTOCLOSE_TIMEOUT = 10 * 1000;

export function useGameErrorToast() {
  const [toast, setToast] = useState<ReactNode>(null);
  const clearToast = useCallback(() => {
    setToast(null);
  }, []);

  const showToast = useCallback((n: ReactNode) => {
    setToast(n);

    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      setToast(null);
    }, TOAST_AUTOCLOSE_TIMEOUT);
  }, []);

  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      timeout.current && clearTimeout(timeout.current);
    };
  }, []);

  return {
    toast: toast ? (
      <Toast type="error" onClose={clearToast}>
        {toast}
      </Toast>
    ) : null,
    showToast,
    clearToast,
  };
}
